import type { BaseController } from '@infra/controllers/base.controller';
import type { GetSignedRecordingUrlUsecase } from '@usecases/get-signed-recording-url.usecase';

export type GetSignedRecordingUrlInput = {
  recordingUrl: string;
};

export type GetSignedRecordingUrlOutput = {
  url: string;
};

export class GetSignedRecordingUrlController
  implements
    BaseController<GetSignedRecordingUrlInput, GetSignedRecordingUrlOutput>
{
  constructor(private usecase: GetSignedRecordingUrlUsecase) {}

  async handle(
    req: GetSignedRecordingUrlInput,
  ): Promise<GetSignedRecordingUrlOutput> {
    return await this.usecase.run(req);
  }
}
